module.exports = __webpack_public_path__ + "static/media/icon-add-group.be0296ed.svg";